import { TranscriptEntry } from '../../../platform-call';

export function filterQuotesByKeyword(
    keyWord: string | null,
    quotes: TranscriptEntry[],
): TranscriptEntry[] {
    if (keyWord == null || keyWord.trim().length === 0) {
        return [...quotes];
    }

    return quotes.filter((q) => {
        return q.text?.toLowerCase().includes(keyWord.toLowerCase());
    });
}
